import { bulkResizeSelector } from "store/features/bulkResize/selectors/bulkResizeSelector";
import { BulkResizeState } from "store/features/bulkResize/types";
import { useAppSelector, useAppDispatch } from "store/store";
import { SocialMediaPlatform } from "@/store/types/resizeSettings";
import { setSocialMediaPlatform } from "store/features/bulkResize/actions";

export const useSocialMediaPlatform = () => {
    const {
        resizeSettings: {
            bySocialMedia: { platform },
        },
    } = useAppSelector(bulkResizeSelector, equalityFn);
    const dispatch = useAppDispatch();

    const handleChange = (value: SocialMediaPlatform) => dispatch(setSocialMediaPlatform(value));

    return {
        platform,
        handleChange,
    };
};

const equalityFn = (left: BulkResizeState, right: BulkResizeState) => {
    if (left.resizeSettings.bySocialMedia.platform.name !== right.resizeSettings.bySocialMedia.platform.name)
        return false;

    return true;
};
